export default __webpack_public_path__ + "static/media/favicon.71c32779.png";